import React from 'react';
import '../../App.css';
//import CSS from 'csstype';
import './search-results.css';
import { withTranslation, WithTranslation } from 'react-i18next';

// icons

// classes
import MiniButton from '../mini-button';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

interface SearchResultsFooterProps extends WithTranslation {
  page: number;
  pageSize: number;
  pages: number;
  rows: number;
  updatePage: any;
  visible?: boolean;
} // SearchResultsFooterProps

interface SearchResultsFooterState {
  visible: boolean;
} // SearchResultsState

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

class SearchResultsFooter extends React.Component<
  SearchResultsFooterProps,
  SearchResultsFooterState
> {
  //
  constructor(props: SearchResultsFooterProps) {
    super(props);
  }

  //	------------------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	------------------------------------------------------------

  render() {
    return (
      <div
        role="navigation"
        className={
          this.props.visible === true
            ? 'search-results-footer'
            : 'search-results-footer-hidden'
        }
        style={{
          gap: '5px',
        }}
      >
        <div className="search-results-showing-count">
          {this.props.t('Showing results from to of', {
            start: this.props.rows > 0 ? this.props.page * this.props.pageSize + 1 : 0,
            end:
              (this.props.page + 1) * this.props.pageSize > this.props.rows
                ? this.props.rows
                : (this.props.page + 1) * this.props.pageSize,
            max: this.props.rows,
          })}
        </div>
        <div style={{ flex: '1 1' }} />
        <MiniButton
          aria-label="Go to first page"
          aria-disabled={this.props.page === 0 ? 'true' : 'false'}
          disabled={this.props.page === 0}
          onClick={() => this.props.updatePage({ page: 0 })}
          tabIndex={this.props.page === 0 ? -1 : 0}
        >
          ≪
        </MiniButton>
        <MiniButton
          aria-label="Go to previous page"
          aria-disabled={this.props.page === 0 ? 'true' : 'false'}
          disabled={this.props.page === 0}
          onClick={() => this.props.updatePage({ page: this.props.page - 1 })}
          tabIndex={this.props.page === 0 ? -1 : 0}
        >
          &lt;
        </MiniButton>
        <MiniButton
          aria-label="Go back two pages"
          hidden={this.props.page <= 1}
          onClick={() => this.props.updatePage({ page: this.props.page - 2 })}
        >
          {this.props.page - 1}
        </MiniButton>
        <MiniButton
          aria-label="Go back one page"
          hidden={this.props.page === 0}
          onClick={() => this.props.updatePage({ page: this.props.page - 1 })}
        >
          {this.props.page}
        </MiniButton>
        <MiniButton data-selected="T" aria-label="Current page" aria-current="page">
          {this.props.page + 1}
        </MiniButton>
        <MiniButton
          aria-label="Go forward one page"
          hidden={this.props.page >= this.props.pages - 1}
          onClick={() => this.props.updatePage({ page: this.props.page + 1 })}
        >
          {this.props.page + 2}
        </MiniButton>
        <MiniButton
          aria-label="Go forward two pages"
          hidden={this.props.page >= this.props.pages - 2}
          onClick={() => this.props.updatePage({ page: this.props.page + 2 })}
        >
          {this.props.page + 3}
        </MiniButton>
        <MiniButton
          aria-label="Go to next page"
          aria-disabled={this.props.page >= this.props.pages - 1 ? 'true' : 'false'}
          disabled={this.props.page >= this.props.pages - 1}
          onClick={() => this.props.updatePage({ page: this.props.page + 1 })}
          tabIndex={this.props.page >= this.props.pages - 1 ? -1 : 0}
        >
          &gt;
        </MiniButton>
        <MiniButton
          aria-label="Go to last page"
          aria-disabled={this.props.page >= this.props.pages - 1 ? 'true' : 'false'}
          disabled={this.props.page >= this.props.pages - 1}
          onClick={() => this.props.updatePage({ page: this.props.pages - 1 })}
          tabIndex={this.props.page >= this.props.pages - 1 ? -1 : 0}
        >
          ≫
        </MiniButton>
      </div>
    );
  }
  //
} // SearchResultsFooter

export default withTranslation()(SearchResultsFooter);
